module.exports = __webpack_public_path__ + "static/media/gridThree.459c6b38.png";